import React from 'react'
import PlaceholderPage from '../../components/shared/PlaceholderPage'
import { FileText } from 'lucide-react'

const features = [
  { name: 'Customer Selection', description: 'Select customer for the proposal' },
  { name: 'Template Library', description: 'Start from pre-built templates' },
  { name: 'Line Item Builder', description: 'Add products and services with pricing' },
  { name: 'Preview & Send', description: 'Preview before sending to customer' },
]

export default function ProposalCreateView() {
  return (
    <PlaceholderPage
      title="Create Proposal"
      description="Build a new customer proposal"
      icon={FileText}
      features={features}
      accentColor="orange"
    />
  )
}
